"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FunnelSelectCardGrid = void 0;

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _common = require("@leanlancer/common");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _SelectCard = _interopRequireDefault(require("../SelectCard"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    container: {
      margin: theme.spacing(3)
    },
    tile: {
      overflow: 'inherit'
    },
    gridlist: {
      justifyContent: function justifyContent(_ref) {
        var centered = _ref.centered;
        return centered ? 'center' : 'inherit';
      }
    }
  };
});

var FunnelSelectCardGrid = function FunnelSelectCardGrid(_ref2) {
  var className = _ref2.className,
      cards = _ref2.cards,
      centered = _ref2.centered,
      props = _objectWithoutProperties(_ref2, ["className", "cards", "centered"]);

  var classes = useStyles({
    centered: centered
  });
  var breakpoint = (0, _common.useBreakpoint)();

  var _useState = (0, _react.useState)(2),
      _useState2 = _slicedToArray(_useState, 2),
      cols = _useState2[0],
      setcols = _useState2[1];

  (0, _react.useEffect)(function () {
    if (breakpoint === 'xs' || breakpoint === 'sm') {
      setcols(2);
    }

    if (breakpoint === 'md') {
      setcols(3);
    }

    if (breakpoint === 'lg' || breakpoint === 'xl') {
      setcols(4);
    }
  }, [breakpoint]);
  return /*#__PURE__*/_react.default.createElement(_core.GridList, {
    cellHeight: 200,
    spacing: 12,
    cols: cols,
    className: classes.gridlist
  }, cards.map(function (card) {
    return /*#__PURE__*/_react.default.createElement(_core.GridListTile, {
      key: card.title,
      classes: {
        tile: classes.tile
      }
    }, /*#__PURE__*/_react.default.createElement(_SelectCard.default, card));
  }));
};

exports.FunnelSelectCardGrid = FunnelSelectCardGrid;
FunnelSelectCardGrid.propTypes = {
  cards: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    tooltip: _propTypes.default.string,
    icon: _propTypes.default.node
  }))
};
var _default = FunnelSelectCardGrid;
exports.default = _default;